import { Flex } from '@chakra-ui/react';
import React from 'react';
import { ClearFiltersButton } from 'src/components/molecules/ClearFiltersButton';
import { LockFiltersButton } from 'src/components/molecules/LockFiltersButton';
import { MasterDataDownloadButton } from 'src/components/molecules/MasterDataDownloadButton';
import { AggregationSelector } from 'src/features/MM/components/molecules/AggregationSelector';
import { DimensionSelector } from 'src/features/MM/components/molecules/DimensionSelector';
import { FilterHeading } from '../../atoms/FilterHeading';
import { FilterBarContainer } from '../../molecules/FilterBarContainer';
import { BenchmarkSelector } from '../BenchmarkSelector';
import { BenchmarkSelectorError } from '../BenchmarkSelector/BenchmarkSelectorError';
import { TimeRangeSelector } from '../TimeRangeSelector';
import { CampaignsMenu } from '../menus/CampaignsMenu';
import { MediaMenu } from '../menus/MediaMenu';
import { CampaignGroupMenu } from '../menus/CampaignGroupMenu';
import { MenuOpenerButton } from 'src/components/atoms/MenuOpenerButton';
import { Icon } from 'src/components/atoms/Icon';

type FilterBarProps = {
  additionalTopFilters?: React.ReactElement;
  includeBenchmark?: boolean;
  includeAggregation?: boolean; // Requires AggregationContext, right now only used in MM
  includeDimension?: boolean; // Requires DimensionContext, right now only used in MM
};

export const FilterBar: React.FC<FilterBarProps> = ({
  additionalTopFilters,
  includeBenchmark,
  includeAggregation,
  includeDimension,
}) => {
  return (
    <FilterBarContainer alignItems="flex-start" py={4} flexDir="column">
      <Flex flexDir="row" w="100%" justifyContent="space-between">
        <Flex flexDir={'row'} wrap="wrap">
          {/* Time Range */}
          <Flex direction="column" mr={3} my={2}>
            <FilterHeading headingText="Time Range" color="text.darkGray" />
            <TimeRangeSelector
              includeTimePeriodButtons
              rightElement={<LockFiltersButton filterType="time range" />}
            />
          </Flex>
          {/* Benchmark Range */}
          {includeBenchmark && (
            <Flex direction="column" mr={3} my={2}>
              <Flex alignItems={'center'}>
                <FilterHeading headingText="Benchmark" color="text.darkGray" />
                <BenchmarkSelectorError />
              </Flex>
              <MenuOpenerButton>
                <Icon iconName="calendar" width={6} height={6} mr={2} />
                <BenchmarkSelector />
              </MenuOpenerButton>
            </Flex>
          )}

          {includeAggregation && (
            <Flex direction="column" mr={3} my={2}>
              <AggregationSelector />
            </Flex>
          )}

          {includeDimension && (
            <Flex direction="column" mr={3} my={2}>
              <DimensionSelector />
            </Flex>
          )}

          {/* Campaign Group */}
          <Flex direction="column" alignItems="flex-star" mr={3} my={2}>
            <FilterHeading headingText="Campaign Group" color="text.darkGray" />
            <MenuOpenerButton>
              <CampaignGroupMenu />
            </MenuOpenerButton>
          </Flex>

          {/* Campaigns */}
          <Flex direction="column" alignItems="flex-star" mr={3} my={2}>
            <FilterHeading headingText="Campaigns" color="text.darkGray" />
            <MenuOpenerButton>
              <CampaignsMenu />
              <LockFiltersButton filterType="campaigns" />
            </MenuOpenerButton>
          </Flex>

          {/* Media */}
          <Flex direction="column" alignItems="flex-start" mr={3} my={2}>
            <FilterHeading headingText="Media" color="text.darkGray" />
            <MenuOpenerButton>
              <MediaMenu />
              <LockFiltersButton filterType="media" />
            </MenuOpenerButton>
          </Flex>

          {additionalTopFilters}
        </Flex>

        <Flex alignItems="flex-end" mb={2}>
          <MenuOpenerButton p={0}>
            <MasterDataDownloadButton />
          </MenuOpenerButton>
        </Flex>
      </Flex>

      {/* Clear Filters */}
      <ClearFiltersButton />
    </FilterBarContainer>
  );
};
